/**
 * Route utility mixin
 */
const routeMixin = {
  methods: {
    /**
     * Check if the current page matches the route (inclusive of parent route)
     * @param {*} name
     */
    isMatchRoute(name) {
      if (this.$route.matched && this.$route.matched.length > 0) {
        const { matched } = this.$route
        for (var i = 0; i < matched.length; i++) {
          if (matched[i].name === name) {
            return true
          }
        }
      }
      return false
    },
    /**
     * Check if the current page matches the route (not inclusive of parent route)
     * @param {*} name
     */
    isMatchRouteExact(name) {
      if (this.$route) {
        if (this.$route.name === name) {
          return true
        }
      }
      return false
    }
  }
}

export default routeMixin
